import { render, staticRenderFns } from "./PedidoCrc.vue?vue&type=template&id=03807172&scoped=true&"
import script from "./PedidoCrc.vue?vue&type=script&lang=js&"
export * from "./PedidoCrc.vue?vue&type=script&lang=js&"
import style0 from "./PedidoCrc.vue?vue&type=style&index=0&id=03807172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03807172",
  null
  
)

export default component.exports